module.exports = "/_next/static/images/e6dda679477765b6b3725050f6991cf9-man-looking-at-phone@xs-1x.jpg";